/**

 * Ray's Loyalty — shared redeem success dialog.

 */

(function () {

  'use strict';



  var registry = {};



  function esc(s) {

    return String(s == null ? '' : s)

      .replace(/&/g, '&amp;')

      .replace(/</g, '&lt;')

      .replace(/"/g, '&quot;');

  }



  function tReplace(str, vars) {

    var s = String(str || '');

    Object.keys(vars || {}).forEach(function (key) {

      var val = vars[key] != null ? String(vars[key]) : '';

      var patterns = [

        new RegExp('\\[\\[\\s*' + key + '\\s*\\]\\]', 'g'),

        new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'),

      ];

      patterns.forEach(function (re) {

        s = s.replace(re, val);

      });

    });

    return s;

  }



  function formatMoneyFromCents(cents) {

    var n = Number(cents);

    if (!isFinite(n)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {

      try {

        return window.Shopify.formatMoney(n, window.theme && window.theme.moneyFormat);

      } catch (e) {}

    }

    return (n / 100).toFixed(2);

  }



  function getDialog(id) {

    return document.getElementById('rl-redeem-success-' + id);

  }



  function applyFreeProductFromDialog(entry, dialog) {

    var payload = entry._lastPayload || {};

    var code = payload.discountCode ? String(payload.discountCode) : '';

    var cart = payload.freeProductCart || null;

    if (!code || !window.RaysLoyalty || typeof window.RaysLoyalty.applyFreeProductDiscountToCart !== 'function') {

      return;

    }

    var btn = dialog.querySelector('[data-rl-redeem-free-product]');

    if (btn) {

      btn.disabled = true;

      btn.classList.add('is-loading');

    }

    window.RaysLoyalty.applyFreeProductDiscountToCart(code, cart).catch(function () {

      if (btn) {

        btn.disabled = false;

        btn.classList.remove('is-loading');

      }

      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart'));

    });

  }



  function bindDialog(entry) {

    var dialog = getDialog(entry.dialogId || entry.id);

    if (!dialog || dialog.dataset.rlBound) return;

    dialog.dataset.rlBound = '1';

    var I = entry.strings;

    dialog.querySelectorAll('[data-rl-redeem-success-close]').forEach(function (el) {

      el.addEventListener('click', function () {

        window.RlRedeemSuccess.close(entry.dialogId || entry.id);

      });

    });

    var copyBtn = dialog.querySelector('[data-rl-redeem-copy]');

    if (copyBtn) {

      copyBtn.addEventListener('click', function () {

        var codeEl = dialog.querySelector('[data-rl-redeem-success-code]');

        var text = codeEl ? codeEl.textContent : '';

        var done = function () {

          copyBtn.textContent = I.successCopied;

          window.setTimeout(function () {

            copyBtn.textContent = I.successCopy;

          }, 2000);

        };

        if (window.RaysLoyalty && typeof window.RaysLoyalty.copyToClipboard === 'function') {

          window.RaysLoyalty.copyToClipboard(text).then(done).catch(done);

        } else if (navigator.clipboard && navigator.clipboard.writeText) {

          navigator.clipboard.writeText(text).then(done).catch(done);

        }

      });

    }

    var freeBtn = dialog.querySelector('[data-rl-redeem-free-product]');

    if (freeBtn) {

      freeBtn.addEventListener('click', function () {

        applyFreeProductFromDialog(entry, dialog);

      });

    }

    var shopBtn = dialog.querySelector('[data-rl-redeem-shop]');

    if (shopBtn) {

      shopBtn.textContent = I.successShop;

      if (entry.shopCtaUrl) shopBtn.setAttribute('href', entry.shopCtaUrl);

    }

    var recBtn = dialog.querySelector('[data-rl-redeem-records]');

    if (recBtn) recBtn.textContent = I.successRecords;

    var coupBtn = dialog.querySelector('[data-rl-redeem-coupons]');

    if (coupBtn) coupBtn.textContent = I.successCoupons;

  }



  function registerFromDom() {

    document.querySelectorAll('[data-rl-redeem-success-config]').forEach(function (node) {

      var id = node.getAttribute('data-rl-redeem-success-config');

      try {

        var cfg = JSON.parse(node.textContent || '{}');

        if (cfg.dialogId) id = cfg.dialogId;

        registry[id] = cfg;

        bindDialog(cfg);

      } catch (e) {}

    });

  }



  window.RlRedeemSuccess = {

    register: function (cfg) {

      if (!cfg || !cfg.dialogId) return;

      registry[cfg.dialogId] = cfg;

      bindDialog(cfg);

    },

    show: function (dialogId, payload, rewardMeta, hooks) {

      hooks = hooks || {};

      var entry = registry[dialogId];

      var dialog = getDialog(dialogId);

      if (!entry || !dialog) {

        if (typeof hooks.onClose === 'function') hooks.onClose();

        return false;

      }

      bindDialog(entry);

      var I = entry.strings;

      var p = payload || {};

      entry._lastPayload = p;

      var title = p.title || (rewardMeta && rewardMeta.title) || '';

      var rewardType = String(p.rewardType || (rewardMeta && rewardMeta.rewardType) || '').toLowerCase();

      var pointsSpent =

        p.pointsSpent != null

          ? p.pointsSpent

          : p.points_spent != null

            ? p.points_spent

            : rewardMeta && rewardMeta.pointsCost != null

              ? rewardMeta.pointsCost

              : null;

      var balance =

        p.pointsBalance != null

          ? p.pointsBalance

          : p.points_balance != null

            ? p.points_balance

            : hooks.pointsBalance != null

              ? hooks.pointsBalance

              : null;

      var code = p.discountCode ? String(p.discountCode) : '';

      var freeProductCart = p.freeProductCart || null;

      var isFreeProduct = rewardType === 'free_product_discount';

      var titleEl = dialog.querySelector('.rays-loyalty-redeem-success-dialog__title');

      var contentEl = dialog.querySelector('.rays-loyalty-redeem-success-dialog__content');

      var codeWrap = dialog.querySelector('.rays-loyalty-redeem-success-dialog__code-wrap');

      var codeEl = dialog.querySelector('[data-rl-redeem-success-code]');

      var tipsEl = dialog.querySelector('[data-rl-redeem-success-tips]');

      var freeBtn = dialog.querySelector('[data-rl-redeem-free-product]');

      var shopBtn = dialog.querySelector('[data-rl-redeem-shop]');

      if (titleEl) titleEl.textContent = I.successTitle;

      if (contentEl) {

        contentEl.innerHTML =

          '<p><span class="highlight">' +

          esc(title) +

          '</span></p><p>' +

          esc(tReplace(I.successSpent, { points: pointsSpent })) +

          '</p><p>' +

          esc(tReplace(I.successBalance, { balance: balance })) +

          '</p>';

      }

      var showCode =

        code &&

        (rewardType.indexOf('discount') !== -1 ||

          rewardType === 'gift_card' ||

          rewardType === 'free_product_discount');

      if (codeWrap) codeWrap.hidden = !showCode;

      if (codeEl) codeEl.textContent = showCode ? code : '';

      var showFreeProductBtn = isFreeProduct && !!code && !!(freeProductCart && (freeProductCart.variantId || freeProductCart.productPath));

      if (freeBtn) {

        freeBtn.hidden = !showFreeProductBtn;

        freeBtn.disabled = false;

        freeBtn.classList.remove('is-loading');

        freeBtn.textContent = I.successAddFreeProduct || 'Add free product to cart';

      }

      if (shopBtn) shopBtn.hidden = showFreeProductBtn;

      if (tipsEl) {

        if (rewardType === 'store_credit') {

          var amt =

            p.storeCreditCents != null

              ? formatMoneyFromCents(p.storeCreditCents)

              : rewardMeta && rewardMeta.storeCreditCents != null

                ? formatMoneyFromCents(rewardMeta.storeCreditCents)

                : '';

          tipsEl.textContent = amt

            ? tReplace(I.successStoreCreditAmount, { amount: amt }) + ' ' + I.successTipsStoreCredit

            : I.successTipsStoreCredit;

        } else if (showFreeProductBtn) {

          tipsEl.textContent = I.successTipsFreeProduct || I.successTipsCode;

        } else if (showCode) {

          tipsEl.textContent = I.successTipsCode;

        } else {

          tipsEl.textContent = '';

        }

      }

      entry._hooks = hooks;

      dialog.hidden = false;

      dialog.setAttribute('data-open', 'true');

      document.body.classList.add('rl-redeem-dialog-open');

      return true;

    },

    close: function (dialogId) {

      var entry = registry[dialogId];

      var dialog = getDialog(dialogId);

      if (!dialog) return;

      dialog.hidden = true;

      dialog.removeAttribute('data-open');

      document.body.classList.remove('rl-redeem-dialog-open');

      if (entry && entry._hooks && typeof entry._hooks.onClose === 'function') {

        var fn = entry._hooks.onClose;

        entry._hooks.onClose = null;

        fn();

      }

    },

  };



  document.addEventListener('DOMContentLoaded', registerFromDom);

  document.addEventListener('shopify:section:load', registerFromDom);

})();

